var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.41079 2.74408c.32543-.32544.85311-.32544 1.17851 0l5.8333 5.83333c.3255.32544.3255.85307 0 1.17851-.3254.32548-.853.32548-1.1785 0l-5.2441-5.24408-5.24404 5.24408c-.32543.32548-.85307.32548-1.17851 0-.32544-.32543-.32544-.85307 0-1.17851zm.58921 8.43442 5.2441 5.2441c.3255.3254.8531.3254 1.1785 0 .3255-.3254.3255-.8531 0-1.1785l-5.8333-5.83336c-.3254-.32543-.85308-.32543-1.17851 0l-5.83334 5.83336c-.32543.3254-.32543.8531 0 1.1785.32544.3254.85308.3254 1.17851 0z",
    fill: "#5a34e1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsUp);
export default __webpack_public_path__ + "static/media/chevrons-up.7f1643d4e815962b98e43bef2f526adb.svg";
export { ForwardRef as ReactComponent };